import AdminToolsIcon from './assets/admin-tools.svg';
import ContentCommsIcon from './assets/content-comms.svg';
import DataAnalysisIcon from './assets/data-analysis.svg';
import ProjectManagementIcon from './assets/project-management.svg';
import SoftwareDevelopmentIcon from './assets/software-development.svg';
export const categories = [{
  id: 'admin-tools',
  name: 'Administrative tools',
  icon: AdminToolsIcon
}, {
  id: 'project-management',
  name: 'Project management',
  icon: ProjectManagementIcon
}, {
  id: 'data-analytics',
  name: 'Data and analytics',
  icon: DataAnalysisIcon
}, {
  id: 'content-communication',
  name: 'Content and communication',
  icon: ContentCommsIcon
}, {
  id: 'software-development',
  name: 'Software development',
  icon: SoftwareDevelopmentIcon
}];